const state = {
    iconList: [
        'icon-ulock',
        'icon-del',
        'icon-update',
        'icon-lock',
        'icon-add',
        'icon-menu'
    ]
}

export default {
    namespaced: true,
    state,
  }


// WEBPACK FOOTER //
// ./src/store/modules/icon.js